import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import QRCode from 'qrcode.react';
import { Controller, useForm } from "react-hook-form";
import { Hidden } from "react-awesome-styled-grid";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, INDIAN_STATES } from "../../appconstants";
import {
  FlexContainer,
  H1Text,
  Hr,
  Input,
  LabelText,
  SubmitButton,
  Text,
  Img,
  PH3Text,
  UpiPanel,
  UpiPanel1,
  RoundButton,
} from "../../design";
import {
  SpError,
} from '../../widgetDesign';
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import { format } from "../../utils/timer";
import SmallScreenView from "../../components/smallscreen";
import {
  addCheckoutPageChargeById,
} from "../../api";

import QRIcon from "../../assets/imgs/qr-img.svg";
import Arrow from "../../assets/imgs/qr-arrow.svg";
import Bhim from "../../assets/imgs/bhim.svg";
import Gpay from "../../assets/imgs/gpay.svg";
import Paytm from "../../assets/imgs/paytm.svg";
import PhonePay from "../../assets/imgs/phonepay.svg";
import User from "../../assets/imgs/paytm-user.svg";
import { Button, Col, Row, Modal } from "antd";
import useDetectWebPageVisibility from "../../hooks/useDetectWebPageVisibility";
import { useDispatch, useSelector } from "react-redux";
import { setIsWaitingForUpiApp, setUserReturnedFromUpiApp } from "../../redux/appConfigInfo";
import UpiAccordion from "./Component/UpiAccordion";

type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  submit: Function,
  getCheckoutById: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  alpha2: string,
  cancel: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  paymentWidget: boolean,
  expireyText: String,
  count: Number,
  checkoutPageId: String,
  supportPhoneNumber: string,
  supportedPaymentTypes: Array,
  onReturnFromUpiApp: Function,
  onChargeByUpiIndent: Function,
}

const UpiCheckout = (props: Props) => {
  const { isTest, submit, preFillCustomer, paymentWidget, expireyText, count, supportPhoneNumber, supportedPaymentTypes,
    headerText, buttonText, errorHeader, errorMsg, alpha2, checkoutPageId, totalAmount, onChargeByUpiIndent, getCheckoutById, onReturnFromUpiApp } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [hideUpiId, setHideUpiId] = useState(true);
  const [address, setAddress] = useState(null);
  const [qrCodeText, setQRCodeText] = useState('');
  const [invalidQR, setInvalidQR] = useState(null);
  const [styleClass, setStyleClass] = useState('col-sm-6 pl-0');
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [paymentSession, setPaymentSession] = useState('');
  const [psClientSecret, setPsClientSecret] = useState('');
  const [redirectionUri, setRedirectionUri] = useState('');
  const [supportNumber, setSupportNumber] = useState(null);
  const [upiId, setUpiId] = useState('');
  const [upiModalVisible, setUpiModalVisible] = useState(false);
  const { isWaitingForUpiApp, userReturnedFromUpiApp } = useSelector((state) => state.appConfigInfo);
  const [, forceUpdate] = useState();
  const dispatch = useDispatch();
  useDetectWebPageVisibility();

  let apiInterval;
  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      validUpi: {
        message: 'The upi id is invalid',
        rule: val => (new RegExp(/^\w.+@\w+$/).exec(val) !== null),
      },
    },
  }));

  useEffect(() => {
    if (paymentWidget) {
      setStyleClass('col-sm-12 pl-0');
    }
  }, [paymentWidget]);

  useEffect(() => {
    if (isWaitingForUpiApp && userReturnedFromUpiApp) {
      onReturnFromUpiApp();
      dispatch(setUserReturnedFromUpiApp(false));
      dispatch(setIsWaitingForUpiApp(false));
    }
  }, [isWaitingForUpiApp, dispatch, userReturnedFromUpiApp, onReturnFromUpiApp]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
  } = useForm();

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      setPhoneNumber(phone && phone.nationalNumber);
      const upiSupportPhone = supportPhoneNumber && AsYouType(supportPhoneNumber);
      setSupportNumber(upiSupportPhone && upiSupportPhone.nationalNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      const address = preFillCustomer && preFillCustomer.billingAddress;
      setAddress(address);
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        address: address && address.street,
        city: address && address.city,
        postalCode: address && address.postalCode,
        state: address && findStateByCode(address.state),
      })
    }
  }, [reset, preFillCustomer]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const findStateByCode = (code) => (
    INDIAN_STATES.find(value => value.code === code)
  );

  useEffect(() => {
    if (!hideUpiId) {
      const interval = setInterval(() => {
        getCheckoutById(paymentSession, psClientSecret, redirectionUri);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [hideUpiId]);

  const onClickQrCode = async (data) => {
    if (data === 'prev') {
      clearInterval(apiInterval);
      setHideUpiId(true);
    } else {
      setLoading(true);
      const data = {
        "paymentMethod": {
          "subType": "QR",
          "type": "UPI"
        },
      }
      try {
        const value = await addCheckoutPageChargeById(checkoutPageId, data);
        if (value && value.paymentSession) {
          const { nextActionUrl } = value;
          if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
          }
          setQRCodeText(value.paymentSession.qrUrl);
          setPaymentSession(value.paymentSession.gid || null);
          setPsClientSecret(value.paymentSession.psClientSecret || null);
          setRedirectionUri(value.redirectUri || null);
          setLoading(false);
          setHideUpiId(false);
        }
      } catch (err) {
        setLoading(false);
        setHideUpiId(true);
        setInvalidQR('QR is not supported for this payment')
        setShowErrorMessage(true);
      }
      setLoading(false);
    }
  };

  const onSubmit = data => {
    const { vpa } = data;
    const paymentMethod = { type: "UPI", upi: { vpa } };
    const finalData = { ...data, paymentMethod };
    if (submit) { submit(finalData) }
  };

  const onUpiSubmit = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setShowErrorMessage(false);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const paymentMethod = { type: "UPI", upi: { vpa: upiId } };
    const finalData = { paymentMethod };
    submit(finalData);
  };

  const customSubmitButtonStyle = {
    width: '100%',
    backgroundColor: '#0b64bc',
    fontSize: '15px',
    fontWeight: '600',
  };

  return (
    <>
      {
        expireyText && (
          <p className="px-1 px-md-4 mb-4">
            {expireyText} <span style={{ fontWeight: "600" }}>{format(count)}</span>
          </p>
        )
      }
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        <SmallScreenView>
          {"Pay With UPI ID"}
        </SmallScreenView>
        <Hidden sm xs>
          {headerText || "Pay With UPI"}
        </Hidden>
      </H1Text>
      <SmallScreenView>
        {navigator.userAgent.match(/iPhone|iPad|iPod/i) && (
          <>
            <div className="mt-2 ml-1 w-50">
              <Input
                placeholder="Enter your Upi ID"
                style={{ border: '1px solid #9A9A9A' }}
                value={upiId}
                onChange={(e) => setUpiId(e.currentTarget.value)}
              />
            </div>
            <div className="ml-1 mt-1">
              <SpError>
                {simpleValidator.current.message('upiId', upiId, 'required|validUpi')}
              </SpError>
            </div>
            <div>
              <Button type="primary" onClick={(e) => onUpiSubmit(e)}>
                Pay
              </Button>
            </div>
          </>
        )}
        {navigator.userAgent.match(/Android/i) && supportedPaymentTypes.includes('UPI_INDENT') && (
          <>
            <Row className='mt-3 justify-content-center align-items-center' gutter={[16, 16]}>
              <Col xs={24} sm={24} md={12} lg={8}>
                <Button style={customSubmitButtonStyle} type="primary" onClick={() => setUpiModalVisible(true)}>
                  Pay with UPI App
                </Button>
              </Col>
            </Row>
            <Modal title="Select App" open={upiModalVisible} footer={null} closable={false}>
              <UpiAccordion fetchUpiUrl={onChargeByUpiIndent} />
            </Modal>
          </>
        )}
        </SmallScreenView>
      <Hidden sm xs>
        <form
          hidden={showQrCode}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)(e);
          }}
          onChange={() => setShowErrorMessage(false)}
          style={{
            width: '100%',
          }}
        >
          {

            loading ? (
              <>
                <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
              </>
            ) : (
              <>
                <FlexContainer
                  flexDirection="column"
                >
                  {
                    hideUpiId ? (
                      <>
                        {/* <div className="px-1 px-md-4 mt-2 w-100">
                          <div className="row m-0">
                            <div className={styleClass}>
                              <LabelText>
                                UPI Id
                              </LabelText>
                              <Controller
                                defaultValue={""}
                                color={errors.vpa ? "red" : "inherit"}
                                marginBottom="0px"
                                control={control}
                                name="vpa"
                                placeholder="Enter your upi id"
                                rules={{
                                  required: 'This field is required',
                                  pattern: {
                                    value: /^\w.+@\w+$/,
                                    message: 'The upi id is invalid',
                                  },
                                }}
                                as={<Input className="w-100" />}
                              />
                              <ErrorMessage
                                errors={invalidQR || errors}
                                name="vpa"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                            </div>
                          </div>
                        </div> */}
                        {/* <Hr /> */}
                        {
                          supportedPaymentTypes && supportedPaymentTypes.includes('QR') ? (
                            <>
                              {
                                (!isTest || (isTest && preFillCustomer.amount <= 100)) ?
                                  <>

                                    <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                                      <div className="row m-0">
                                        <div
                                          onClick={() => onClickQrCode('next')}
                                          className={styleClass}>
                                          <UpiPanel>
                                            <Img
                                              style={{
                                                marginTop: '19px',
                                                marginLeft: '16px',
                                              }}
                                              src={QRIcon}
                                            />
                                            <PH3Text>Show QR</PH3Text>
                                            <PH3Text
                                              marginTop='5px'
                                              fontSize='11px'
                                              color='#848484'
                                            >
                                              Scan the QR code using your UPI app
                                            </PH3Text>
                                            <p
                                              style={{
                                                marginLeft: '90%',
                                                marginTop: '-19px',
                                              }}
                                            >
                                              <Img
                                                src={Arrow}
                                              />
                                            </p>
                                          </UpiPanel>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <Hr /> */}
                                  </>
                                  : null
                              }
                            </>
                          ) : null
                        }

                        {/* <div className="px-1 px-md-4">
                          <FlexContainer
                            width="100%"
                            justifyContent="space-between"
                          >
                            <SubmitButton
                              type="submit"
                              className="ml-5"
                            >{buttonText || "PAY"}</SubmitButton>
                          </FlexContainer>
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#484848">
                            *No fees applicable for UPI/QR payments
                          </Text>
                          {/* {isShowErrorMessage && <PaymentError header={invalidQR || errorHeader} message={errorMsg} />} */}
                          {/* isShowErrorMessage && invalidQR && <PaymentError header={invalidQR} message={errorMsg} /> */}
                        {/* </div> */}
                      </>
                    ) : (
                      <>
                        <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                          <div className="row m-0">
                            <div
                              onClick={() => onClickQrCode('prev')}
                              className={styleClass}>
                              <UpiPanel>
                                <Img
                                  style={{
                                    marginTop: '19px',
                                    marginLeft: '16px',
                                  }}
                                  src={User}
                                />
                                <PH3Text>UPI ID</PH3Text>
                                <PH3Text
                                  marginTop='5px'
                                  fontSize='11px'
                                  color='#848484'
                                >
                                  Use your UPI Id
                                </PH3Text>
                                <p
                                  style={{
                                    marginLeft: '90%',
                                    marginTop: '-19px',
                                  }}
                                >
                                  <Img
                                    src={Arrow}
                                  />
                                </p>
                              </UpiPanel>
                            </div>
                          </div>
                        </div>
                        <Hr />
                        <div className="px-1 px-md-4 mt-2 mb-4 w-100">
                          <div className="row m-0">
                            <div className={styleClass}>
                              <H1Text className="mt-4">
                                PAY USING QR CODE
                              </H1Text>
                              <UpiPanel1>
                                <PH3Text
                                  marginTop='40px'
                                  marginLeft='35px'
                                  fontSize='11px'
                                  color='#848484'
                                >
                                  Scan the QR using any UPI app on your phone
                                </PH3Text>
                                <PH3Text
                                  marginTop='5px'
                                  marginLeft='40px'
                                  fontSize='11px'
                                  color='#848484'
                                >
                                  like BHIM, PhonePe, Google Pay etc.
                                </PH3Text>
                                <div
                                  style={{
                                    marginTop: '15px',
                                    marginLeft: '55px',
                                  }}
                                >
                                  <Img
                                    src={Bhim}
                                    marginRight='15px'
                                  />
                                  <Img
                                    src={PhonePay}
                                    marginRight='15px'
                                  />
                                  <Img
                                    src={Gpay}
                                    marginRight='15px'
                                  />
                                  <Img
                                    src={Paytm}
                                    marginRight='15px'
                                  />
                                </div>
                                <div
                                  style={{
                                    marginTop: '40px',
                                    marginLeft: '20%',
                                  }}
                                >
                                  <QRCode
                                    id="qrCodeEl"
                                    size={160}
                                    value={qrCodeText}
                                  />
                                </div>
                              </UpiPanel1>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                </FlexContainer>
              </>
            )
          }
        </form>
      </Hidden>
    </>
  )
};

export default UpiCheckout;
